var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 9"},[React.createElement("g",{"data-name":"Rectangle 85","fill":"#fff","stroke":"#707070","key":0},[React.createElement("path",{"stroke":"none","d":"M24.5 6.9h64v68h-64z","key":0}),React.createElement("path",{"fill":"none","d":"M25 7.4h63v67H25z","key":1})]),React.createElement("path",{"d":"M109.54 12.3a14.06 14.06 0 0 0-9.89-9.95C90.93 0 55.95 0 55.95 0s-35 0-43.72 2.35a14.06 14.06 0 0 0-9.9 9.96C0 21.09 0 39.4 0 39.4s0 18.32 2.34 27.1a13.85 13.85 0 0 0 9.89 9.8c8.72 2.35 43.71 2.35 43.71 2.35s34.99 0 43.71-2.35a13.85 13.85 0 0 0 9.9-9.8c2.33-8.78 2.33-27.1 2.33-27.1s0-18.32-2.34-27.1ZM44.5 56.06V22.78L73.74 39.4Z","fill":"#ed6a5d","key":1})]));
}

Play.defaultProps = {"viewBox":"0 0 111.88 78.67"};

module.exports = Play;

Play.default = Play;
